import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import { FiraSansBold } from 'components/Text';

const Dialog = styled.div`
  width: 90%; 
  max-height: 75%; 
  background-color: rgba(255,255,255,0.4);
  box-shadow: 0px 1px 5px 2px ${Colors.GRAY[3]};
  border-radius: 4px;

  ${({ canShow }) =>
    canShow
      ? css`
        display: flex;
        flex-direction: column;
        `
      : `display: none;`
  }
`;

const DialogBody = styled.div`
  background-color: #fefefe;
  padding: 25px;
  width: 100%
  height: auto;
  min-height: 100px;
  max-height: calc(100% - 130px);
  overflow-y: auto;
`;

const DialogButtonsContainer = styled.div`
  background-color: #fefefe;
  padding: 10px 25px 10px;
  width: 100%;
  height: 60px;
  display: flex;
  border-radius: 0px 4px 4px;
  justify-content: flex-end;
  align-items: center;
  box-shadow: 0px 1px 5px 2px ${Colors.GRAY[3]};
  border-radius: 4px;

  buttons {
    margin: 0 !important;
  }
`

const DialogHeader = styled.div`
  margin: auto;  
  width: 100%
  display: flex;
  align-items: center;
  padding: 25px;
  box-shadow: 0px 1px 5px 2px ${Colors.GRAY[3]};
  height: 70px;
  border-radius: 4px;
  background: ${Colors.BLUE};

  color: ${Colors.WHITE};
  font-weight: ${FiraSansBold};
  font-family: 'Fira Sans', sans-serif;
  font-size: 14px;
`;

export {
  Dialog,
  DialogBody,
  DialogHeader,
  DialogButtonsContainer
}